import {IToggleProps} from 'components/FluentUICompat';
import {
	PropsWithAriaDescribedBy,
	TooltipWithComponentWithAriaDescribedBy,
} from 'features/localizedTooltips';
import React from 'react';
import {HookFormProps} from '../HookFormProps';

type PropsWithLabel = Pick<IToggleProps, 'label'>;

type ControlledToggleLabelProps = PropsWithLabel & PropsWithAriaDescribedBy;

function ControlledToggleLabel({
	label,
	'aria-describedby': ariaDescribedBy,
}: ControlledToggleLabelProps): React.ReactElement {
	return (
		<span aria-describedby={ariaDescribedBy}>{label as React.ReactNode}</span>
	);
}

type Props = PropsWithLabel & Pick<HookFormProps, 'name'>;

export const ControlledToggleLabelWithTooltip = (
	props: Props,
): React.ReactElement => {
	const Host =
		TooltipWithComponentWithAriaDescribedBy<ControlledToggleLabelProps>;

	return (
		<Host
			Component={ControlledToggleLabel}
			tooltipHostProps={{translationKey: props.name}}
			{...props}
		/>
	);
};
